// extracted by mini-css-extract-plugin
export default {"page":"NewsHandbookPage_page__RgBln","split":"NewsHandbookPage_split__Cg8Dh"};